export default __webpack_public_path__ + "static/media/Fence's Bracers of Ushering Twilight.ce11f907.jpg";